module.exports = __webpack_public_path__ + "ic-user.svg?9eac498081c71a424f39e0b732c5a869";